// Prezzo per veicolo che scende con la flotta, da €16 a €8: il prezzo della
// fascia vale per tutti i veicoli.
const PRICING_TIERS = [
  { maxVehicles: 10, pricePerVehicle: 16 },
  { maxVehicles: 25, pricePerVehicle: 15 },
  { maxVehicles: 50, pricePerVehicle: 14 },
  { maxVehicles: 100, pricePerVehicle: 13 },
  { maxVehicles: 200, pricePerVehicle: 12 },
  { maxVehicles: 350, pricePerVehicle: 11 },
  { maxVehicles: 500, pricePerVehicle: 10 },
  { maxVehicles: 750, pricePerVehicle: 9 },
  { maxVehicles: 1000, pricePerVehicle: 8 },
];
const CUSTOM_ABOVE = 1000;

// Le tappe dello slider; l'ultima vale "oltre 1.000".
const VEHICLE_STEPS = [
  1, 3, 5, 10, 15, 25, 35, 50, 75, 100, 150, 200, 300, 400, 500, 650, 750, 1000, 1001,
];

export const DEFAULT_STEP = VEHICLE_STEPS.indexOf(10);
export const LAST_STEP = VEHICLE_STEPS.length - 1;

const count = (n) => n.toLocaleString('it-IT');

/**
 * Il piano di una tappa dello slider: veicoli, prezzo per veicolo e totale al
 * mese, o `custom` oltre i 1.000 veicoli.
 */
export function planForStep(step) {
  const vehicles = VEHICLE_STEPS[step];
  if (vehicles > CUSTOM_ABOVE) {
    return { vehicles, custom: true, label: 'Oltre 1.000 veicoli' };
  }
  const { pricePerVehicle } = PRICING_TIERS.find((tier) => vehicles <= tier.maxVehicles);
  return {
    vehicles,
    custom: false,
    label: `${count(vehicles)} ${vehicles === 1 ? 'veicolo' : 'veicoli'}`,
    total: `€${count(vehicles * pricePerVehicle)} / mese`,
    breakdown: `${count(vehicles)} × €${pricePerVehicle}/veicolo al mese`,
  };
}
